$eve_tab $eve_button
	size null
	variant \text
	colors <= tab_colors \primary
	selected? false
	attr *
		^
		eve_selected <= selected? false
		aria-checked <= aria_checked \false
		role \tab
		aria-selected <= aria_checked
